
import { useState } from "react";
import { URL_ASPIRANTES_INSCRITOS } from "../../api/url";
import { carreras } from "../../data/datos";

const useAspirantesInscritos = () => {

    const [carreraSeleccionada, setCarreraSeleccionada] = useState( 1 )

    // funciones
    const generarReporteInscritos = () => {

        let nombre_materia_seleccionada = carreras.find( e => {
            // eslint-disable-next-line
            if ( e.id == carreraSeleccionada ) {
                return e;
            }
        })

        let carrera_sel = nombre_materia_seleccionada.nom_carrera

        let body = new FormData();
        body.append( 'carreraSeleccionada', carreraSeleccionada )

        fetch( URL_ASPIRANTES_INSCRITOS, {
            method: 'post',
            body
        })
        .then( r => r.blob() )
        .then( d => {
            let pdf = URL.createObjectURL(d);
            var anchor = document.createElement("a");
            anchor.download = carrera_sel;
            anchor.href = pdf;
            anchor.click();
        })
        .catch( () => alert("Error al generar reporte") )

    }


    return {
        generarReporteInscritos,
        carreraSeleccionada,
        setCarreraSeleccionada
    }
}

export default useAspirantesInscritos
